import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import formAppLayoutPosterMatrixComponent from './formAppLayoutPosterMatrixComponent';

export default {
  title: 'Space Canvas',
  attributeName: 'appLayout',
  helpText: 'This section is to control how many and what content will appear in the Room. It can be reorganized into different forms',
  fields: [
    {
      attributeName: 'posterMatrixPanels',
      type: FormInputTypes.CANVAS,
      label: '',
      helpText: '',
      configFile: formAppLayoutPosterMatrixComponent
    },
  ],
};

